var _t = function t() {
    return _t = Object.assign || function (t) {
      for (var a, c = 1, e = arguments.length; c < e; c++) for (var o in a = arguments[c]) Object.prototype.hasOwnProperty.call(a, o) && (t[o] = a[o]);
      return t;
    }, _t.apply(this, arguments);
  },
  a = 0,
  c = function () {
    function t(t) {
      this.list = [], this.callbackMap = {}, this.callback = t || function (t) {
        return t.isIntersecting;
      }, this.observer = new IntersectionObserver(this._observeCallback.bind(this));
    }
    return t.getModspace = function (t) {
      return t || "modspace_".concat(++a);
    }, t.prototype.install = function (t) {
      t.prototype.$bmgObserver = this;
    }, t.prototype._observeCallback = function (t) {
      var a = this;
      t.forEach(function (t) {
        var c = t.target,
          e = c.__modspace__,
          o = a.callback(t, e);
        o && a.callbackMap[e] && (a.callbackMap[e].forEach(function (t) {
          return t(o);
        }), a.unobserve({
          el: c,
          modspace: e
        }));
      });
    }, t.prototype._addCallback = function (t, a) {
      Array.isArray(this.callbackMap[t]) ? this.callbackMap[t].push(a) : this.callbackMap[t] = [a];
    }, t.prototype._removeCallback = function (t, a) {
      if (this.callbackMap[t]) {
        var c = this.callbackMap[t].findIndex(function (t) {
          return t === a;
        });
        this.callbackMap[t].splice(c, 1);
      }
    }, t.prototype.observe = function (a, c) {
      var e = this,
        o = t.getModspace(a.modspace);
      if (!(c = a.callback || c)) throw new Error("please set a callback for observe");
      this.unobserve(a);
      var i = a.el;
      i.__modspace__ = o, this._addCallback(o, c), this.observer.observe(i);
      var r = {
        el: a.el,
        modspace: o,
        callback: c
      };
      return this.list.push(r), function () {
        return e.unobserve(r);
      };
    }, t.prototype.unobserve = function (t) {
      var a = this.list.findIndex(function (a) {
        return a.el === t.el;
      });
      if (a > -1) {
        var c = this.list[a],
          e = c.el,
          o = c.modspace,
          i = c.callback;
        this.observer.unobserve(e), this._removeCallback(o, i);
      }
    }, t.prototype.disconnect = function () {
      var t = this;
      for (var a in this.list.forEach(function (a) {
        t.unobserve(a);
      }), this.callbackMap) {
        for (; this.callbackMap[a].length;) this.callbackMap[a].pop();
        delete this.callbackMap[a];
      }
      this.observer.disconnect();
    }, t;
  }(),
  e = function () {
    function a(t) {
      this.callbackMap = {}, this.switchMap = {}, t && this.initSwitch(t);
    }
    return a.prototype.install = function (t) {
      t.prototype.$bmgObserver = this;
    }, a.prototype.initSwitch = function (t) {
      var a = this;
      this.switchMap = {}, t.forEach(function (t) {
        a.switchMap[t] = !1;
      });
    }, a.prototype.toggleSwitch = function (t, a) {
      console.log(this.switchMap[t], a), "boolean" == typeof this.switchMap[t] && this.switchMap[t] !== a && this.callbackMap[t].forEach(function (t) {
        return t(a);
      }), this.switchMap[t] = a;
    }, a.prototype._addCallback = function (t, a) {
      Array.isArray(this.callbackMap[t]) ? (console.log(t, "1", this.callbackMap[t].length), this.callbackMap[t].push(a)) : (console.log(t, "2"), this.callbackMap[t] = [a]);
    }, a.prototype._removeCallback = function (t, a) {
      if (this.callbackMap[t]) {
        var c = this.callbackMap[t].findIndex(function (t) {
          return t === a;
        });
        this.callbackMap[t].splice(c, 1);
      }
    }, a.prototype.observe = function (a, e) {
      var o = this,
        i = c.getModspace(a.modspace);
      if (!(e = a.callback || e)) throw new Error("please set a callback for observe");
      return a.el.__modspace__ = i, void 0 === this.switchMap[i] || this.switchMap[i] ? (e(!0), function () {}) : (this._addCallback(i, e), function () {
        return o.unobserve(_t(_t({}, a), {
          callback: e
        }));
      });
    }, a.prototype.unobserve = function (t) {
      var a = t.modspace,
        c = t.callback;
      this._removeCallback(a, c);
    }, a.prototype.disconnect = function () {
      for (var t in this.callbackMap) {
        for (; this.callbackMap[t].length;) this.callbackMap[t].pop();
        delete this.callbackMap[t], delete this.switchMap[t];
      }
    }, a;
  }();
export { e as BmgAsyncTaskObserver, c as BmgIntersectionObserver };
